// extracted by mini-css-extract-plugin
export default {"plus_content_item":"plus_content_item__66f98826","thumbnail_image":"thumbnail_image__66f98826","title":"title__66f98826","sub_title":"sub_title__66f98826"};